import { useContext, useEffect } from 'react'
import { useTheme } from 'styled-components'
import { useMediaQuery } from '@mui/material'
import { Context } from './NavbarContext'

const useNavbar = (): { onPresent: () => void; onDismiss: () => void; isOpen: boolean } => {
  const { onPresent, onDismiss, isOpen } = useContext(Context)
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.mediaQueries.tablet)

  useEffect(() => {
    if (isOpen && !isTablet) onDismiss()
  }, [isTablet, isOpen])

  return { onPresent, onDismiss, isOpen }
}

export default useNavbar
